export class DropDownItem {
  constructor(
    public value: any,
    public name?: string,
  ) {
  }
}
